import {Fetch} from "@/apis/Fetch";

export class FinModelsAPI {
    static async getUserTemplates(){
        let data = await Fetch('GET','api/fin_models/templates/get_user_templates');
        return data;
    }

    static async getOtherTemplates(){
        let data = await Fetch('GET','api/fin_models/templates');
        return data;
    }

    static async getTemplate(templateId){
        let data = await Fetch('GET','api/fin_models/templates/'+templateId);
        return data;
    }
}